// extracted by mini-css-extract-plugin
module.exports = {"form":"form--N6Kh7","fullWidth":"fullWidth--DTdT3","item":"item--83mGj","submitButton":"submitButton--SH3IU"};